import { successToast } from 'configuration/notifications';

export const BaseService = {
  copyUrl: (url) => {
    navigator.clipboard.writeText(url);
    successToast('Ссылка скопирована в буфер обмена');
  },

  async getBase64FromFiles(files) {
    return Promise.all(Array.from(files).map(async (file) => await BaseService.toBase64(file)));
  },

  toBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  },
};
